export default "__VITE_ASSET__B9U47x1h__"